import React from "react";
import {
  CardWrapperVariant,
  CardsDataModel,
} from "@models/strapi-components/card-wrapper";
import Title from "@components/common/Title";
import ImageRenderer from "@components/common/Image";
import Link from "@components/common/Link";

export interface CardPropsModel {
  cardData: CardsDataModel;
  variant: CardWrapperVariant;
}

const variantBasedClassName: Record<
  CardWrapperVariant,
  Record<string, string>
> = {
  [CardWrapperVariant.BASE]: {
    wrapperClassName:
      "p-8 max-w-[419px] bg-white rounded-xl card-wrapper-card-base",
    imageWrapper: "overflow-hidden p-2",
    titleSubTitleWrapper: "mt-5 px-2",
  },
  [CardWrapperVariant.INTEGRATION]: {
    wrapperClassName:
      "p-0 w-[436px] bg-white card-wrapper-card-integration h-full rounded-lg",
    imageWrapper:
      "p-14 h-[199px] overflow-hidden flex items-center justify-center",
    titleSubTitleWrapper: "p-9",
  },
};

const Cards: React.FunctionComponent<CardPropsModel> = ({
  cardData,
  variant = CardWrapperVariant.BASE,
}) => {
  const {
    title = "",
    subTitle,
    cardImage,
    imgBackgroundColor,
    logoImage,
    learnMoreLink,
    learnMoreText,
  } = cardData;
  const { wrapperClassName, imageWrapper, titleSubTitleWrapper } =
    variantBasedClassName[variant];

  const imageWrapperAdditionalStyle =
    variant === CardWrapperVariant.INTEGRATION && imgBackgroundColor
      ? {
          backgroundColor: imgBackgroundColor,
        }
      : {};

  const imageToRender =
    variant === CardWrapperVariant.BASE ? cardImage : logoImage;

  const isVariantIntegration = variant === CardWrapperVariant.INTEGRATION;

  const renderCard = () => (
    <div className={wrapperClassName} style={{ height: "100%" }}>
      {imageToRender && (
        <div className={imageWrapper} style={imageWrapperAdditionalStyle}>
          <ImageRenderer image={imageToRender} alt={title ?? ""} />
        </div>
      )}
      {title || subTitle ? (
        <div className={titleSubTitleWrapper}>
          {title && <Title variant="h3" titleText={title} />}
          {subTitle && <Title variant="paragraph" titleText={subTitle} />}
        </div>
      ) : (
        <></>
      )}
      {learnMoreText && learnMoreLink && (
        <div className="px-2">
          <Link linkText={learnMoreText} href={learnMoreLink} />
        </div>
      )}
    </div>
  );
  return isVariantIntegration && learnMoreLink?.length ? (
    <a href={learnMoreLink} className="cursor-pointer">
      {renderCard()}
    </a>
  ) : (
    renderCard()
  );
};
export default Cards;
